const btnClearFilterManagementService = {
  Typography: 'Clear'
};

export default btnClearFilterManagementService;
